import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Trans, withNamespaces } from 'react-i18next';

import { Center } from 'legacyComponents/styled/lib';
import Icon from 'components/Icon';
import Button from 'components/Button';

@withNamespaces()
@observer
export class NoFinderData extends React.Component {
  render() {
    const { manager, inputRef, t } = this.props;
    const { projects, input, ClearInput } = manager;
    if (projects && projects.length === 0 && input.includes('/')) {
      return (
        <Wrapper>
          <NoProjectIcon>
            <Icon name='folder' />
          </NoProjectIcon>
          <Title>
            <Trans>No Projects to show</Trans>
          </Title>
          <Description>
            <Trans>
              Hmm... Looks like <b>{input.split('/')[0]}</b> doesn&#39;t have
              any projects yet! Try searching for something else.
            </Trans>
          </Description>
          <Center>
            <ButtonStyled
              text={t('Do another search')}
              onClick={() => ClearInput(inputRef)}
              size='small'
              outline
            />
          </Center>
        </Wrapper>
      );
    }

    return (
      <Wrapper>
        <SearchIcon>
          <Icon name='search' />
        </SearchIcon>
        <Title>
          <Trans>Embed any file from Wikifactory</Trans>
        </Title>
        <Description>
          <Trans>
            Simply search for projects by <b>@username</b> or{' '}
            <b>+organisation</b>, then navigate to and select the file you&#39;d
            like to embed.
          </Trans>
        </Description>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  padding: 60px 20px;
`;

const SearchIcon = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${props => props.theme.color.primary};
  color: ${props => props.theme.color.wfWhite};
  border-radius: 50%;
  transition: left 250ms ease-in-out;
  text-align: center;
  margin: 0 auto;
  line-height: 36px;
`;

const NoProjectIcon = styled(SearchIcon)`
  background-color: ${props => props.theme.color.wfOrange};
`;

const Title = styled.h1`
  font-size: 1em;
  text-align: center;
  margin: 20px 0px 15px 0px;
`;

const Description = styled.p`
  margin: 0px auto;
  text-align: center;
  line-height: 1.4;
  max-width: 60%;
`;

const ButtonStyled = styled(Button)`
  margin-top: ${props => props.theme.spacing.medium};
`;

NoFinderData.propTypes = {
  t: PropTypes.func,
  manager: PropTypes.object,
  inputRef: PropTypes.node,
};
